// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // production: false,
  // apiUrl: 'https://localhost:44327',
  // // usmApiUrl: 'https://localhost:44328',

  // appUrl: 'http://localhost:4202',

  // // apiUrl: 'http://192.168.100.4:3021',
  // usmApiUrl: 'http://192.168.100.4:3011',
  // flmApiUrl: 'http://192.168.100.4:3081',
  // portalApiUrl: 'http://192.168.100.4:3001',
  // keycloakUrl: 'http://192.168.100.4:8088',
  // abmApiUrl: 'http://192.168.100.4:3091',

  // realm: 'GoeplaRealm',
  // clientid: 'GoeplaClient',

  // apiUrl: 'http://144.91.108.116:3021',
  // abmApiUrl: 'http://144.91.108.116:3091',
  // flmApiUrl: 'http://144.91.108.116:3081',
  // portalApiUrl: 'http://144.91.108.116:3001',
  // usmApiUrl: 'http://144.91.108.116:3011',
  // keycloakUrl: 'https://144.91.108.116:8443',

  production: true,
  apiUrl: window["env"]["APIURL"] || "default",
  appUrl: window["env"]["APPURL"] || "default",
  usmApiUrl: window["env"]["USMAPIURL"] || "default",
  flmApiUrl: window["env"]["FLMAPIURL"] || "default",
  keycloakUrl: window["env"]["KEYCLOAKURL"] || "default",
  realm: window["env"]["REALM"] || "default",
  clientid: window["env"]["CLIENTID"] || "default",
  portalApiUrl: window["env"]["PORTALAPIURL"] || "default",
  abmApiUrl: window["env"]["ABMAPIURL"] || "default"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
